/* unplugin-vue-components disabled */import { render } from "./w-empty.vue?vue&type=template&id=6ab59716&ts=true"
import script from "./w-empty.vue?vue&type=script&lang=ts"
export * from "./w-empty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__